(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/frejaeid-poll.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/frejaeid-poll.js');

'use strict';

const _svs$playerLoginReact = svs.playerLoginReact.constants,
  frejaeIdPollType = _svs$playerLoginReact.frejaeIdPollType,
  appWaitStatus = _svs$playerLoginReact.appWaitStatus,
  loginType = _svs$playerLoginReact.loginType;
const _svs$playerLoginReact2 = svs.playerLoginReact.store.playerloginreactactions,
  setPlayerLoginType = _svs$playerLoginReact2.setPlayerLoginType,
  setIsLogin = _svs$playerLoginReact2.setIsLogin;
const _svs$playerLoginReact3 = svs.playerLoginReact.frejaeid.components,
  FrejaeIdStart = _svs$playerLoginReact3.FrejaeIdStart,
  FrejaeIdWaiting = _svs$playerLoginReact3.FrejaeIdWaiting;
const UpdateHeader = svs.playerLoginReact.sharedComponents.UpdateHeader;

const FrejaeIdPoll = _ref => {
  let _ref$isLogin = _ref.isLogin,
    isLogin = _ref$isLogin === void 0 ? true : _ref$isLogin,
    _ref$pollState = _ref.pollState,
    pollState = _ref$pollState === void 0 ? frejaeIdPollType.BEFORE_POLL : _ref$pollState,
    _ref$frejaeIdPollWait = _ref.frejaeIdPollWait,
    frejaeIdPollWait = _ref$frejaeIdPollWait === void 0 ? appWaitStatus.WAITING_QRCODE : _ref$frejaeIdPollWait;
  const dispatch = ReactRedux.useDispatch();
  React.useEffect(() => {
    dispatch(setPlayerLoginType(loginType.FREJAEID));
    dispatch(setIsLogin(isLogin));
    UpdateHeader.updateHeader(isLogin ? 'Logga in' : 'Bli kund');
  }, [dispatch, isLogin]);
  return React.createElement(React.Fragment, null, pollState === frejaeIdPollType.BEFORE_POLL && React.createElement(FrejaeIdStart, {
    isLogin: isLogin
  }), pollState === frejaeIdPollType.WAITING_POLL && React.createElement(FrejaeIdWaiting, {
    frejaeIdPollWait: frejaeIdPollWait,
    isLogin: isLogin
  }));
};
svs.playerLoginReact.frejaeid.FrejaeIdPoll = FrejaeIdPoll;

 })(window);